
import * as XLSX from 'xlsx';

interface ExcelGuardRow {
  'Όνομα': string;
  'Επώνυμο': string;
  'Κωδικός': string;
  'Email': string;
  'Πρόσληψη'?: number | string;
  'Ημερ.γέννησης'?: number | string;
  'ΛΗΞΗ ΑΔΕΙΑΣ'?: number | string;
  'ΑΦΜ'?: string;
  'Ομάδα'?: string;
  'Κινητό'?: string;
}

const excelDateToJSDate = (excelDate: number): Date => {
  const utc_days  = Math.floor(excelDate - 25569);
  const utc_value = utc_days * 86400;                                        
  const date_info = new Date(utc_value * 1000);
  return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate());
};

const formatDateForDB = (date: Date): string => {
  return date.toISOString().split('T')[0];
};

export const downloadGuardsTemplate = () => {
  const template = [
    {
      'Όνομα': '',
      'Επώνυμο': '',
      'Κωδικός': '',
      'Email': '',
      'Πρόσληψη': '',
      'Ημερ.γέννησης': '',
      'ΛΗΞΗ ΑΔΕΙΑΣ': '',
      'ΑΦΜ': '',
      'Ομάδα': '',
      'Κινητό': ''
    }
  ];

  const ws = XLSX.utils.json_to_sheet(template);
  
  const colWidths = [
    { wch: 15 }, // Όνομα
    { wch: 15 }, // Επώνυμο
    { wch: 10 }, // Κωδικός
    { wch: 25 }, // Email
    { wch: 12 }, // Πρόσληψη
    { wch: 15 }, // Ημερ.γέννησης
    { wch: 15 }, // ΛΗΞΗ ΑΔΕΙΑΣ
    { wch: 12 }, // ΑΦΜ
    { wch: 15 }, // Ομάδα
    { wch: 15 }  // Κινητό
  ];
  ws['!cols'] = colWidths;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Template");
  
  const notes = XLSX.utils.aoa_to_sheet([
    ['Instructions:'],
    ['1. All dates should be in DD/MM/YYYY format'],
    ['2. Email is required and must be valid'],
    ['3. ΑΦΜ is optional but must be valid if provided'],
    ['4. Team name is optional - if provided, guards will be assigned to that team'],
    ['5. Required fields: Όνομα (First Name), Επώνυμο (Last Name), Κωδικός, Email'],
    ['6. Mobile phone is optional but should be in international format (e.g., +301234567890)'],
    ['7. First Name (Όνομα) and Last Name (Επώνυμο) must be provided in separate columns']
  ]);
  XLSX.utils.book_append_sheet(wb, notes, "Instructions");

  XLSX.writeFile(wb, "guards-template.xlsx");
};

export const parseExcelFile = (file: File): Promise<ExcelGuardRow[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (event) => {
      try {
        const data = event.target?.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet) as ExcelGuardRow[];

        const processedData = jsonData.map((row: ExcelGuardRow) => ({
          'Όνομα': row['Όνομα'] || '',
          'Επώνυμο': row['Επώνυμο'] || '',
          'Κωδικός': row['Κωδικός'] || '',
          'Email': row['Email'] || '',
          'Πρόσληψη': row['Πρόσληψη'] && typeof row['Πρόσληψη'] === 'number' 
            ? formatDateForDB(excelDateToJSDate(row['Πρόσληψη']))
            : row['Πρόσληψη'] || null,
          'Ημερ.γέννησης': row['Ημερ.γέννησης'] && typeof row['Ημερ.γέννησης'] === 'number'
            ? formatDateForDB(excelDateToJSDate(row['Ημερ.γέννησης']))
            : row['Ημερ.γέννησης'] || null,
          'ΛΗΞΗ ΑΔΕΙΑΣ': row['ΛΗΞΗ ΑΔΕΙΑΣ'] && typeof row['ΛΗΞΗ ΑΔΕΙΑΣ'] === 'number'
            ? formatDateForDB(excelDateToJSDate(row['ΛΗΞΗ ΑΔΕΙΑΣ']))
            : row['ΛΗΞΗ ΑΔΕΙΑΣ'] || null,
          'ΑΦΜ': row['ΑΦΜ'] || null,
          'Ομάδα': row['Ομάδα'] || null,
          'Κινητό': row['Κινητό'] || null
        }));

        resolve(processedData);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = () => {
      reject(new Error("Failed to read file"));
    };

    reader.readAsBinaryString(file);
  });
};
